import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Link from "@mui/material/Link";
import Container from "../../../common/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Avatar } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { blue } from "@mui/material/colors";
import hackathon from "../../../assets/images/hackathon.png";

const latest = [
  //   {
  //     img: ,
  //     title: " Tunde Onakoya bags BudgIT’s Active Citizens Award",
  //     date: "September 18, 2022",
  //     links: "/tunde-onakoya-bags-budgit-active-citizens-award",
  //   },
];

const FirstPost = () => {
  const theme = useTheme();

  const handleShare = (e) => {
    e.preventDefault();

    const ahref = window.location.href;
    const encodedAhref = encodeURIComponent(ahref);
    var link;

    switch (e.currentTarget.id) {
      case "facebook":
        link = `https://www.facebook.com/sharer/sharer.php?u=${ahref}`;
        open(link);
        break;

      case "twitter":
        link = `https://twitter.com/intent/tweet?url=${encodedAhref}`;
        open(link);
        break;

      case "linkedin":
        link = `https://www.linkedin.com/sharing/share-offsite/?url=${ahref}`;
        open(link);
        break;

      default:
        break;
    }
  };

  const open = (socialLink) => {
    window.open(socialLink, "_blank");
  };

  return (
    <Box>
      <Helmet>
        <title> Blog | Oluseun Onigbinde Resource Centre</title>
      </Helmet>
      <AppBar
        position={"fixed"}
        sx={{
          backgroundColor: theme.palette.background.paper,
        }}
        elevation={0}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 }}>
          <Header />
        </Container>
      </AppBar>
      <Container>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "75%" }}
            paddingTop={{ xs: "35%", sm: "10%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box display={"flex"} alignItems={"center"} marginBottom={"5%"}>
              <img src={hackathon} alt="logo" width="95%" />
            </Box>
            <Typography
              variant="h4"
              color={"#071783"}
              fontWeight={700}
              paddingBottom={{ xs: "10%", sm: "5%" }}
              textAlign={"center"}
            >
              Not Lagos. Not Abuja. Ogbomosho: Where Real Solutions Were Born at
              OORC Ideation 2026
            </Typography>
            <Box
              paddingBottom={{ xs: "10%", sm: "5%" }}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              width={{ xs: "90%", sm: "55%" }}
              marginLeft={0}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                width={{ xs: "45%", sm: "35%" }}
                paddingBottom={{ xs: "5%", sm: "0%" }}
              >
                <CalendarTodayIcon sx={{ color: "#071783" }} />
                <Typography variant="body1" color={"#4f4f4f"}>
                  June 10, 2026
                </Typography>
              </Box>
              <Box width={{ xs: "65%", sm: "40%" }}>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon fontSize="small" />}
                >
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="#071783"
                    href="/"
                  >
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    Home
                  </Link>
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="#071783"
                    href="/Blog"
                  >
                    Blog
                  </Link>
                </Breadcrumbs>
              </Box>
            </Box>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Innovation isn’t just for tech hubs and big cities. The OORC
              Ideation 2026 proved that Ogbomosho has its own powerhouse of
              talent ready to solve local challenges. This two-day hackathon,
              held on May 29-30 at the OORC Innovation Hub, brought together
              students, entrepreneurs, and problem-solvers to develop practical
              solutions for real issues affecting Ogbomosho and its communities.
            </Typography>
            <Typography
              variant="h6"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              fontWeight={700}
              color={"#000"}
            >
              The Problem We Wanted to Solve
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Earlier this year, OORC ran an incubation program that attracted
              promising ideas from young founders. But there was a catch: many
              participants struggled to connect their solutions to the real
              needs of Ogbomosho. Instead of continuing with the same approach,
              OORC decided to flip the script. They identified pressing local
              challenges and invited innovators to build solutions around them –
              that’s how the OORC Ideation 2026 was born.
            </Typography>
            <Typography
              variant="h6"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              fontWeight={700}
              color={"#000"}
            >
              Who Applied + Who Got In
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              The response to the call for applications exceeded expectations.
              Over 60 innovators, students, and founders from Ogbomosho and
              surrounding towns applied within 2 weeks of the announcement.
              After a competitive review process focused on problem
              understanding and local relevance, 10 teams with 23 participants
              were selected to join the Ideation. The applicant pool reflected
              the diversity OORC set out to attract — from university
              undergraduates to young entrepreneurs and self-taught developers.
              The demand alone proved one thing: Ogbomosho is ready to build.
            </Typography>
            <Typography
              variant="h6"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              fontWeight={700}
              color={"#000"}
            >
              A Hackathon with a Difference
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Unlike typical hackathons that prioritize tech for tech’s sake,
              OORC Ideation focuses on understanding problems, validating ideas,
              and building feasible, impactful solutions. Participants tackled
              challenges in agriculture, healthcare, education, waste
              management, and community safety – issues that hit close to home.
            </Typography>
            <Typography
              variant="h6"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              fontWeight={700}
              color={"#000"}
            >
              The Journey: Day by Day
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Day one kicked off with participants digging deep into problem
              discovery, brainstorming, and solution design. The focus was on
              understanding people, not just coding. Day two was all about
              refining ideas, getting mentorship, and pitching solutions to a
              panel of judges.
            </Typography>
            <Typography
              variant="h6"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              fontWeight={700}
              color={"#000"}
            >
              And the Winners Are…
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "1%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              After intense deliberation, the judges picked the top teams:
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              <strong>PathFind (₦1,000,000) </strong> – A career guidance
              platform helping students find their path.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              <strong>Cyfe (₦500,000) </strong>– A smart gas monitoring system
              for safer households.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              <strong>InfantGuard (₦300,000) </strong>– A low-cost device
              detecting pneumonia and respiratory distress in kids.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              <strong>CleanMosho (₦100,000)</strong> – A community-driven waste
              management solution.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              <strong>BloodLink (₦100,000)</strong> – Connecting hospitals and
              blood donors in emergencies.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              What’s Next?
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              The real work starts now. Winning teams will submit implementation
              plans, opening doors to mentorship, partnerships, and pilot
              opportunities. The goal isn’t just to win – it’s to build
              solutions that create impact.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              OORC Ideation 2026 showed that innovation thrives when people
              engage with their community’s challenges. The journey doesn’t end
              here; for many teams, it’s just the beginning.
            </Typography>
            <Typography
              variant="body1"
              fontWeight={700}
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              #OORCIdeation2026 #BuildForOgbomosho
            </Typography>

            <Box
              marginTop={"5%"}
              width={{ xs: "60%", sm: "40%" }}
              marginLeft={0}
            >
              <Typography variant="body1" fontWeight={700} color={"#071783"}>
                Share this post
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  width={{ xs: "70%", sm: "50%" }}
                  marginLeft={"0%"}
                >
                  <Avatar
                    sx={{
                      bgcolor: blue[900],
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="facebook"
                    onClick={handleShare}
                  >
                    <FacebookIcon />
                  </Avatar>
                  <Avatar
                    sx={{
                      bgcolor: "#000",
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="twitter"
                    onClick={handleShare}
                  >
                    <XIcon />
                  </Avatar>
                  <Avatar
                    sx={{
                      bgcolor: blue[700],
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="linkedin"
                    onClick={handleShare}
                  >
                    <LinkedInIcon
                      sx={{
                        bgcolor: blue[700],
                      }}
                    />
                  </Avatar>
                </Box>
              </Typography>
            </Box>
          </Box>
          <Box
            width={{ xs: "92%", sm: "20%" }}
            marginTop={{ xs: "25%", sm: "10%" }}
          >
            <Typography variant="h5" fontWeight={700} color={"#071783"}>
              Related Posts
            </Typography>
            {latest.map((post, index) => (
              <Box
                marginTop={"10%"}
                display={"flex"}
                key={index}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexWrap={{ xs: "wrap", sm: "none" }}
              >
                <Box
                  display={"flex"}
                  alignItems={"left"}
                  marginBottom={"5%"}
                  marginLeft={{ xs: "0%", sm: "0%" }}
                  width={{ xs: "65%", sm: "40%" }}
                >
                  <img src={post.img} alt="logo" width={"100%"} />
                </Box>
                <Box width={{ xs: "100%", sm: "50%" }}>
                  <Link
                    variant="body2"
                    color={"#071783"}
                    fontWeight={500}
                    paddingBottom={{ xs: "10%", sm: "5%" }}
                    textAlign={"center"}
                    href={post.links}
                    underline="hover"
                  >
                    {post.title}
                  </Link>
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    color={"#aaa"}
                    paddingTop={"2%"}
                  >
                    {post.date}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
      <Box bgcolor={"#fff"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default FirstPost;
